(function () {
  "use strict";

  var mount = document.getElementById("vortex-archives-app");
  if (!mount || mount.getAttribute("data-ready") === "true") return;
  mount.setAttribute("data-ready", "true");

  var STORAGE_KEY = "stwl_vortex_archives_v1";
  var SLATE_IMAGE = "https://cdn.shopify.com/s/files/1/0709/3675/6398/files/slatesparkbanner.jpg?v=1786366741";

  mount.innerHTML =
    '<div class="va-shell">' +
      '<header class="va-hero">' +
        '<p class="va-eyebrow"><span class="va-light" aria-hidden="true"></span>THE VORTEX ARCHIVES</p>' +
        '<h1>My Vortex Archives</h1>' +
        '<p class="va-intro">Spin. Reveal. Collect. Recover hidden exhibits throughout the Lab and preserve each discovery in your personal Archives.</p>' +
        '<div class="va-summary" aria-live="polite"><strong class="va-total">0 OF 1</strong><span>EXHIBITS ARCHIVED</span></div>' +
      '</header>' +
      '<div class="va-grid">' +
        '<article class="va-card is-locked" data-archive-id="slate-spark">' +
          '<div class="va-image">' +
            '<img src="' + SLATE_IMAGE + '&width=900" alt="Slate Spark Vortex Archive exhibit" width="1500" height="1091">' +
            '<div class="va-veil" aria-hidden="true"><span>?</span></div>' +
            '<span class="va-state">UNRECOVERED</span>' +
          '</div>' +
          '<div class="va-body">' +
            '<div class="va-heading"><div><small>EXHIBIT 01 · PET NAME LAB</small><h2>Slate Spark</h2></div><span class="va-fraction">0/6</span></div>' +
            '<div class="va-progress" role="progressbar" aria-label="Slate Spark recovery" aria-valuemin="0" aria-valuemax="6" aria-valuenow="0"><span></span></div>' +
            '<p class="va-message">Find the Slate Spark wheel and begin the recovery.</p>' +
            '<div class="va-actions"><a class="va-link" href="/pages/slate-spark">Visit Slate Spark</a><button class="va-collect" type="button" hidden>Add to My Archives</button><span class="va-date"></span></div>' +
          '</div>' +
        '</article>' +
      '</div>' +
      '<p class="va-note">Your Archives are saved on this browser.</p>' +
    '</div>';

  function readCollection() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function saveCollection(collection) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(collection));
      return true;
    } catch (error) {
      return false;
    }
  }

  function formatDate(value) {
    if (!value) return "";
    try {
      return "ARCHIVED " + new Intl.DateTimeFormat(undefined, { year: "numeric", month: "short", day: "numeric" }).format(new Date(value)).toUpperCase();
    } catch (error) {
      return "ARCHIVED";
    }
  }

  function render() {
    var collection = readCollection();
    var record = collection["slate-spark"] || {};
    var total = Math.max(1, parseInt(record.total, 10) || 6);
    var progress = Math.max(0, Math.min(total, parseInt(record.progress, 10) || 0));
    var recovered = record.recovered === true || progress >= total;
    var archived = record.collected === true;
    var state = archived ? "archived" : recovered ? "ready" : progress > 0 ? "in-progress" : "locked";
    var card = mount.querySelector(".va-card");
    var message = mount.querySelector(".va-message");
    card.className = "va-card is-" + state;
    mount.querySelector(".va-fraction").textContent = progress + "/" + total;
    mount.querySelector(".va-progress").setAttribute("aria-valuenow", String(progress));
    mount.querySelector(".va-progress span").style.width = Math.round(progress / total * 100) + "%";
    mount.querySelector(".va-state").textContent = archived ? "ARCHIVED" : recovered ? "RECOVERED" : progress > 0 ? "RECOVERY IN PROGRESS" : "UNRECOVERED";
    mount.querySelector(".va-link").hidden = recovered;
    mount.querySelector(".va-collect").hidden = !recovered || archived;
    mount.querySelector(".va-date").textContent = archived ? formatDate(record.collectedAt) : "";
    mount.querySelector(".va-total").textContent = (archived ? 1 : 0) + " OF 1";
    if (archived) message.textContent = "This recovered exhibit is preserved in your Vortex Archives.";
    else if (recovered) message.textContent = "Recovery complete. Add this exhibit to your Archives.";
    else if (progress > 0) message.textContent = progress + " of " + total + " reveals complete. Keep spinning to finish the recovery.";
    else message.textContent = "Find the Slate Spark wheel and begin the recovery.";
  }

  mount.addEventListener("click", function (event) {
    if (!event.target.closest(".va-collect")) return;
    var collection = readCollection();
    var record = collection["slate-spark"] || {};
    var total = Math.max(1, parseInt(record.total, 10) || 6);
    if ((parseInt(record.progress, 10) || 0) < total && record.recovered !== true) return;
    record.id = "slate-spark";
    record.title = "Slate Spark";
    record.exhibit = "01";
    record.division = "Pet Name Lab";
    record.image = SLATE_IMAGE;
    record.progress = total;
    record.total = total;
    record.recovered = true;
    record.collected = true;
    record.collectedAt = record.collectedAt || new Date().toISOString();
    collection[record.id] = record;
    if (saveCollection(collection)) render();
  });

  window.addEventListener("storage", function (event) { if (event.key === STORAGE_KEY) render(); });
  window.addEventListener("vortex:archive-collected", render);
  render();
})();
